import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cards',
  styleUrls: ['./cards.component.scss'],
  templateUrl: './cards.component.html',
})
export class CardsComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  readonly activeTabIndex$ = this.route.queryParams.pipe(
    map(params => params['card'] || '0'),
    takeUntil(this.destroy$)
  );

  get activeTabIndex() {
    return this.route.snapshot.queryParams.card || '0';
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {
    // Subscribe to query param changes to update the view
    this.activeTabIndex$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  tabChangeHandler(data: MatTabChangeEvent) {
    this.router.navigate(['cards'], { queryParams: { card: data.index } });
  }

}
